import type { QuizQuestion, QuizFieldType } from "../quiz.types";
import { mapQuestionTypeToComponentAndProps } from "./mapQuestionTypeToComponentAndProps";
import { makeQuizQuestionInputKey } from "./makeQuizQuestionInputKey";

/**
 * Transforms quiz questions into form field definitions.
 * Maps question data to the QuizFieldType format used by form components.
 */
export function makeQuestionSetFormFields(
  questions: QuizQuestion[]
): QuizFieldType[] {
  return questions.map(
    ({
      id,
      required,
      prompt,
      additional_info,
      choices,
      type,
      validation_rules,
      config_object,
      image,
      question_logic,
      user_uploaded_media,
      maximum_answers,
    }) => {
      return {
        id,
        name: makeQuizQuestionInputKey(id),
        label: prompt,
        helpText: additional_info || undefined,
        choices,
        type,
        required,
        validation_rules,
        image,
        labelVariant: "body1",
        question_logic: Array.isArray(question_logic)
          ? question_logic?.[0]
          : question_logic ?? undefined,
        // Pass previously uploaded media as initialFiles for file-type questions
        initialFiles: user_uploaded_media,
        ...mapQuestionTypeToComponentAndProps(
          choices,
          type,
          config_object,
          validation_rules,
          maximum_answers
        ),
      };
    }
  );
}

